export default "__VITE_ASSET__B9ph$mL$__"